/**
 * @generated SignedSource<<011d7eb76acbe935ab1cdfebf80e54d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDutiesMessage_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedDutiesMessage_item";
};
export type PdpSharedDutiesMessage_item$key = {
  readonly " $data"?: PdpSharedDutiesMessage_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDutiesMessage_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDutiesMessage_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "8244e1d69d1db10b84c9a3afd61e96ae";

export default node;
